/** Home's greeting ("Good afternoon, Lukas") and the day above it ("Friday, October 30"):
 * the page's header on desktop, the phone's top bar on Home. */
export const greetingText = (t, user, now = new Date()) => {
  const hour = now.getHours();
  const part = hour < 12 ? t('agenda.good_morning') : hour < 17 ? t('agenda.good_afternoon') : t('agenda.good_evening');
  const name = user?.full_name?.split(' ')[0] || t('ui_views.agenda.greeting_fallback_name');
  return `${part}, ${name}`;
};

export const todayText = (lang, now = new Date()) => {
  const text = now.toLocaleDateString(lang, { weekday: 'long', month: 'long', day: 'numeric' });
  return text.charAt(0).toLocaleUpperCase(lang) + text.slice(1);
};
